import { type AirState } from '~/store/types';

export const uploadingPathToBoardIdSelector = ({ uploadingPathToBoardId }: AirState) => uploadingPathToBoardId;
